import "core-js/modules/es.array.push.js";
import moment from "moment";
import { phoneDesc, EncryptName, isPhoneNumber } from "../../util/index";
import { useMainStore } from "../../pinia/main";
import avatarUrl from "../../assets/imgs/defaultportrait.png";
import { onMounted, getCurrentInstance, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { AuthTypeMap, invoiceTypeList } from "@/util/type";
import { ElMessage } from "element-plus";
export default {
  name: "PersonalInformation",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      info: {},
      identityAuth: -1,
      invoiceTitleList: [],
      dialog: {
        invoiceId: "",
        visible: false
      },
      provinces: [],
      cities: [],
      districts: [],
      counties: []
    });
    const formRef = ref();
    const formData = reactive({
      invoiceType: "1",
      name: "",
      taxNo: "",
      phone: "",
      email: "",
      isDefault: true,
      taxableCounty: "",
      taxableDistrict: "",
      taxableProvince: "",
      taxableCity: "",
      workPhone: "",
      bankNo: "",
      workAddress: "",
      openBank: ""
    });
    const rules = {
      name: {
        required: true,
        message: "请输入名称",
        trigger: "blur"
      },
      taxNo: {
        required: true,
        message: "请输入纳税人识别号",
        trigger: "blur"
      },
      phone: [{
        required: true,
        message: "请输入手机",
        trigger: "blur"
      }, {
        validator: (rule, value, callback) => {
          if (isPhoneNumber(value)) {
            callback();
          } else {
            callback(new Error("请输入有效手机号"));
          }
        }
      }],
      email: [{
        required: true,
        message: "请输入邮箱",
        trigger: "blur"
      }, {
        validator: (rule, value, callback) => {
          const passwordRegex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
          if (passwordRegex.test(value)) {
            callback();
          } else {
            callback(new Error("邮箱格式有误"));
          }
        }
      }],
      taxableCounty: {
        required: true,
        message: "请选择应税地(县)",
        trigger: "change"
      },
      taxableProvince: {
        required: true,
        message: "请选择应税地(省)",
        trigger: "change"
      },
      taxableCity: {
        required: true,
        message: "请选择应税地(市)",
        trigger: "change"
      },
      taxableDistrict: {
        required: true,
        message: "请选择应税地(区)",
        trigger: "change"
      }
    };
    onMounted(() => {
      selectProvincesAdDivisionList();
      selectCustomerAuth();
      invoiceTitleList();
    });

    //获取省行政代码
    const selectProvincesAdDivisionList = async () => {
      const res = await globalProperties.$api.selectAdDivisionList({
        adDivisionLevel: 1,
        parentAdDivisionCode: ""
      });
      data.provinces = res;
    };
    //获取除省行政以外的代码
    const selectOtherAdDivisionList = async (parentAdDivisionCode, keyName, isChange = true) => {
      if (isChange) {
        switch (keyName) {
          case "cities":
            formData.taxableCity = "";
            formData.taxableDistrict = "";
            formData.taxableCounty = "";
            data.cities = [];
            data.districts = [];
            data.counties = [];
            break;
          case "districts":
            formData.taxableDistrict = "";
            formData.taxableCounty = "";
            data.districts = [];
            data.counties = [];
            break;
          case "counties":
            formData.taxableCounty = "";
            data.counties = [];
            break;
          default:
            break;
        }
      }
      const res = await globalProperties.$api.selectAdDivisionList({
        parentAdDivisionCode
      });
      data[keyName] = res;
    };

    //查询发票抬头列表
    const invoiceTitleList = async () => {
      const res = await globalProperties.$api.selectOne();
      res && (data.invoiceTitleList = [res]);
    };

    //获取认证信息
    const selectCustomerAuth = async () => {
      var {
        identityAuth
      } = await globalProperties.$api.selectCustomerAuth();
      data.identityAuth = identityAuth;
    };

    //开启弹窗
    const openDialog = async (record = "") => {
      if (record) {
        data.dialog.invoiceId = record.invoiceId;
        formData.invoiceType = record.invoiceType;
        formData.name = record.name;
        formData.taxNo = record.taxNo;
        formData.phone = record.phone;
        formData.email = record.email;
        formData.isDefault = record.isDefault ? true : false;
        formData.taxableCounty = record.taxableCounty;
        formData.taxableDistrict = record.taxableDistrict;
        formData.taxableProvince = record.taxableProvince;
        formData.taxableCity = record.taxableCity;
        formData.workPhone = record.workPhone;
        formData.bankNo = record.bankNo;
        formData.workAddress = record.workAddress;
        formData.openBank = record.openBank;
        const citiesCode = data.provinces.filter(item => item.adDivisionName == formData.taxableProvince)[0].adDivisionCode;
        await selectOtherAdDivisionList(citiesCode, "cities", false);
        const districtsCode = data.cities.filter(item => item.adDivisionName == formData.taxableCity)[0].adDivisionCode;
        await selectOtherAdDivisionList(districtsCode, "districts", false);
        const countiesCode = data.districts.filter(item => item.adDivisionName == formData.taxableDistrict)[0].adDivisionCode;
        await selectOtherAdDivisionList(countiesCode, "counties", false);
      }
      data.dialog.visible = true;
    };

    //关闭弹窗
    const closeDialog = () => {
      data.dialog.visible = false;
      data.dialog.invoiceId = "";
      formData.taxableProvince = "";
      formData.taxableCity = "";
      formData.isDefault = false;
      formRef.value?.resetFields();
    };

    //删除发票抬头
    const invoiceTitleDelete = async invoiceId => {
      var res = await globalProperties.$api.invoiceTitleDelete(invoiceId);
      if (res) {
        ElMessage.success("删除成功");
        data.invoiceTitleList = [];
      }
    };
    const goVerify = () => router.push({
      path: "/layout/auth"
    });
    const submitForm = async formEl => {
      if (!formEl) return;
      await formEl.validate(async (valid, fields) => {
        if (valid) {
          formData.isDefault = formData.isDefault ? 1 : 0;
          let params = {
            ...formData
          };
          if (data.dialog.invoiceId) params.invoiceId = data.dialog.invoiceId;
          var res = await globalProperties.$api.saveOrUpdateInvoiceTitle(params);
          if (res) {
            ElMessage.success(data.dialog.invoiceId ? "修改成功" : "新增成功");
            invoiceTitleList();
            closeDialog();
          }
        }
      });
    };
    return {
      mainStore,
      closeDialog,
      openDialog,
      avatarUrl,
      invoiceTypeList,
      data,
      phoneDesc,
      selectOtherAdDivisionList,
      EncryptName,
      moment,
      AuthTypeMap,
      goVerify,
      invoiceTitleDelete,
      submitForm,
      formRef,
      rules,
      formData
    };
  }
};